import { render, staticRenderFns } from "./TableCuadro6.vue?vue&type=template&id=92b3c694&scoped=true&"
import script from "./TableCuadro6.vue?vue&type=script&lang=js&"
export * from "./TableCuadro6.vue?vue&type=script&lang=js&"
import style0 from "./TableCuadro6.vue?vue&type=style&index=0&id=92b3c694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b3c694",
  null
  
)

export default component.exports